(function () {
  const WIDGET_SIZE_SELECTOR = '.js-oke-widgetSize';
  const WRITE_REVIEW_SELECTOR = '.oke-w-reviews-writeReview';
  const CONTROLS_SELECTOR = '.oke-w-controls';
  const HEADER_CONTENT_SELECTOR = '.oke-w-header-content';
  const CAROUSEL_NEXT_SELECTOR = '.oke-mediaCarousel-next';
  const HEADER_CONTENT_TWO_THIRDS_SELECTOR = '.oke-w-header-content-block--twoThirds';
  const CAROUSEL_NEXT_ICON_CLASS = 'yk-oke-carousel-next-icon';
  const CAROUSEL_NEXT_ICON_SVG =
    '<svg class="' +
    CAROUSEL_NEXT_ICON_CLASS +
    '" xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none"><path d="M0.5 12.5L6.5 6.5L0.5 0.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const GALLERY_NAV_NEXT_SELECTOR = '.oke-mediaGallery-nav-next';
  const GALLERY_NAV_PREV_SELECTOR = '.oke-mediaGallery-nav-prev';
  const MODAL_SELECTOR = '.oke-modal';
  const MODAL_CLOSE_SELECTOR = '.oke-modal-close';
  const PRODUCT_NAME_SELECTOR = '.oke-product-details-name';
  const PRODUCT_VARIANT_SELECTOR = '.oke-product-details-variant';
  const REVIEW_SIMPLE_VARIANT_SELECTOR = '.oke-w-reviewSimple-variant';
  const MODAL_HEADER_CLASS = 'yk-oke-modal-header';
  const MODAL_TITLE_CLASS = 'yk-oke-modal-title';
  const CAROUSEL_PREV_SELECTOR = '.oke-mediaCarousel-prev';
  const CAROUSEL_PREV_ICON_CLASS = 'yk-oke-carousel-prev-icon';
  const CAROUSEL_PREV_ICON_SVG =
    '<svg class="' +
    CAROUSEL_PREV_ICON_CLASS +
    '" xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none"><path d="M0.5 12.5L6.5 6.5L0.5 0.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const FILTER_TOGGLE_SELECTOR = '.oke-w-reviews-filterToggle';
  const REVIEWS_CONTROLS_SELECTOR = '.oke-w-reviews-controls';
  const REVIEWS_SORT_SELECTOR = '.oke-w-reviews-sort';
  const REVIEWS_COUNT_SELECTOR = '.oke-w-reviews-count';
  const REVIEWS_HEAD_SELECTOR = '.oke-w-reviews-head';
  const TEXT_SEARCH_FILTER_GROUP_SELECTOR = '.oke-w-filter.oke-w-filter--text-search';
  const CONTROLS_ACTIONS_CLASS = 'yk-oke-reviews-controls-actions';
  const REVIEWS_CONTROLS_CONTAINER_CLASSES = ['flex', 'flex-wrap', 'items-center', 'justify-between'];
  const TEXT_SEARCH_GROUP_CLASSES = ['order-1', 'w-full', 'lg:w-auto'];
  const CONTROLS_ACTIONS_CLASSES = [
    'flex',
    'items-center',
    'order-2',
    'w-full',
    'justify-between',
    'lg:w-auto',
    'lg:justify-start',
    'lg:gap-x-4',
  ];
  const REVIEWS_COUNT_CLASSES = ['order-4', 'w-full'];
  const REVIEWS_HEAD_CLASSES = ['order-3', 'w-full'];
  const FILTER_TOGGLE_ICON_SELECTOR = '.oke-w-reviews-filterToggle .oke-icon';
  const FILTER_TOGGLE_ICON_CLASS = 'yk-oke-filter-icon';
  const FILTER_TOGGLE_ICON_SVG =
    '<svg class="' +
    FILTER_TOGGLE_ICON_CLASS +
    '" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M8.33333 4.16667H2.5M10 15.8333H2.5M11.6667 2.5V5.83333M13.3333 14.1667V17.5M17.5 10H10M17.5 15.8333H13.3333M17.5 4.16667H11.6667M6.66667 8.33333V11.6667M6.66667 10H2.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const TEXT_SEARCH_FILTER_SELECTOR = '.oke-w-textSearchFilter';
  const TEXT_SEARCH_FILTER_ICON_CLASS = 'yk-oke-search-icon';
  const TEXT_SEARCH_FILTER_ICON_SVG =
    '<span class="' +
    TEXT_SEARCH_FILTER_ICON_CLASS +
    '"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M14 14L11.1333 11.1333M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
  const REVIEWS_SUMMARY_CONTAINER_SELECTOR = '.oke-reviewsSummary';
  const REVIEWS_SUMMARY_TEXT_SELECTOR = '.oke-reviewsSummary-summary.oke-bodyText';
  const REVIEWS_SUMMARY_COUNT_CLASS = 'yk-oke-reviewsSummary-count';
  const REVIEWS_SUMMARY_COUNT_TEXT_CLASS = 'yk-oke-reviewsSummary-count-text';
  const REVIEWS_SUMMARY_COUNT_CLASSES = [
    'flex',
    'items-center',
    'gap-x-1.5',
    'mt-2',
    'text-xxs',
    'text-text-secondary',
  ];
  const REVIEWS_SUMMARY_COUNT_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M5.5 7.5V5.5M5.5 3.5H5.505M10.5 5.5C10.5 8.26142 8.26142 10.5 5.5 10.5C2.73858 10.5 0.5 8.26142 0.5 5.5C0.5 2.73858 2.73858 0.5 5.5 0.5C8.26142 0.5 10.5 2.73858 10.5 5.5Z" stroke="#7B7B7B" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const NAV_BAR_ITEM_COUNT_SELECTOR = '.oke-w-navBar-item .oke-w-navBar-item-count';
  const REVIEWS_KEYWORDS_HEADING_TEXT_SELECTOR = '.oke-reviewsKeywords-heading-text';
  const REVIEWS_KEYWORDS_HEADING_TEXT = 'Klienci najczęściej wspominali o:';
  const CUSTOM_WRAPPER_CLASS = 'yk-custom-header-oke';
  const TITLE_CLASS = 'yk-custom-header-oke-title';
  const TITLE_TEXT = 'Opinie o produkcie';
  const TITLE_TAILWIND_CLASSES = [
    'font-ivyprestoHeadline',
    'font-light',
    'text-[30px]',
    'lg:text-[36px]',
    'tracking-[0.9px]',
    'lg:tracking-[1.08px]',
  ];
  const TAB_SELECTOR = '[role="tab"]';
  const QUESTIONS_TAB_ID_PREFIX = 'questions-tab-';
  const REVIEWS_TAB_ID_PREFIX = 'reviews-tab-';
  const QUESTIONS_EMPTY_STATE_SELECTOR = '.oke-w-questionsTab .oke-state-empty';
  const QUESTIONS_EMPTY_STATE_TEXT_SELECTOR = '.oke-state-empty-text';
  const QUESTIONS_EMPTY_STATE_HEADING_CLASS = 'yk-oke-questions-empty-heading';
  const QUESTIONS_EMPTY_STATE_HEADING_TEXT = 'Masz pytanie? Śmiało!';
  const QUESTIONS_EMPTY_STATE_HEADING_TAILWIND_CLASSES = [
    'font-bold',
    'leading-[26.1px]',
    'text-[18px]',
    'tracking-[0.18px]',
    'mb-2',
  ];
  const QUESTIONS_EMPTY_STATE_TEXT_CONTENT =
    'Chętnie odpowiemy na wszystko, co pomoże Ci wybrać najlepszy produkt dla siebie.';
  const REVIEWS_EMPTY_STATE_SELECTOR = '.oke-w-reviewsTab .oke-state-empty';
  const REVIEWS_EMPTY_STATE_TEXT_SELECTOR = '.oke-state-empty-text';
  const REVIEWS_EMPTY_STATE_HEADING_CLASS = 'yk-oke-reviews-empty-heading';
  const REVIEWS_EMPTY_STATE_HEADING_TEXT = 'Ten produkt czeka na swoją pierwszą historię ✨';
  const REVIEWS_EMPTY_STATE_TEXT_CONTENT =
    'Twoja opinia pomoże innym podjąć dobrą decyzję, a Tobie zajmie tylko chwilę!';
  const QW_HEADER_SELECTOR = '.oke-qw-header';
  const QUESTIONS_TITLE_TEXT = 'Pytania do produktu';
  const QW_QUESTION_SELECTOR = '.oke-qw-question';
  const QW_ANSWER_SELECTOR = '.oke-qw-answer';
  const QW_SIDE_CLASS = 'yk-oke-qw-side';
  const QW_CONTENT_CLASS = 'yk-oke-qw-content';
  const QW_VERIFIED_HTML =
    '<div class="oke-w-reviewer-verified"> Zweryfikowany kupujący <span class="oke-w-reviewer-verified-icon"></span></div>';
  const QW_QUESTION_TEXT_CLASS = 'yk-oke-qw-question-text';
  const LOG_PREFIX = '[yk-okendo]';

  let isQuestionsTabActive = false;

  function ensureTitle(wrapper, text) {
    if (wrapper.querySelector(`:scope > .${TITLE_CLASS}`)) return;

    const title = document.createElement('div');
    title.classList.add(TITLE_CLASS, ...TITLE_TAILWIND_CLASSES);
    title.textContent = text;

    wrapper.insertBefore(title, wrapper.firstChild);
  }

  function ensureQuestionsHeaderTitle() {
    const header = document.querySelector(QW_HEADER_SELECTOR);
    if (!header) return;

    ensureTitle(header, QUESTIONS_TITLE_TEXT);
  }

  function ensureWrapperAfterControls(widgetSize, wrapper) {
    const controls = widgetSize.querySelector(`:scope > ${CONTROLS_SELECTOR}`);
    if (!controls) return;
    if (controls.nextElementSibling === wrapper) return;

    controls.insertAdjacentElement('afterend', wrapper);
  }

  function ensureControlsActionsWrapper(reviewsControls) {
    let actionsWrapper = reviewsControls.querySelector(`:scope > .${CONTROLS_ACTIONS_CLASS}`);
    if (!actionsWrapper) {
      actionsWrapper = document.createElement('div');
      actionsWrapper.classList.add(CONTROLS_ACTIONS_CLASS, ...CONTROLS_ACTIONS_CLASSES);
      reviewsControls.appendChild(actionsWrapper);
    }
    return actionsWrapper;
  }

  function ensureReviewsControlsLayout(widgetSize) {
    const reviewsControls = widgetSize.querySelector(REVIEWS_CONTROLS_SELECTOR);
    if (!reviewsControls) return;

    reviewsControls.classList.add(...REVIEWS_CONTROLS_CONTAINER_CLASSES);

    const textSearchGroup = widgetSize.querySelector(TEXT_SEARCH_FILTER_GROUP_SELECTOR);
    if (textSearchGroup) {
      textSearchGroup.classList.add(...TEXT_SEARCH_GROUP_CLASSES);
      if (reviewsControls.firstElementChild !== textSearchGroup) {
        reviewsControls.insertBefore(textSearchGroup, reviewsControls.firstChild);
      }
    }

    const countEl = widgetSize.querySelector(REVIEWS_COUNT_SELECTOR);
    if (countEl) countEl.classList.add(...REVIEWS_COUNT_CLASSES);

    const actionsWrapper = ensureControlsActionsWrapper(reviewsControls);

    const sortEl = widgetSize.querySelector(REVIEWS_SORT_SELECTOR);
    if (sortEl && !actionsWrapper.contains(sortEl)) {
      actionsWrapper.appendChild(sortEl);
    }

    const filterToggle = widgetSize.querySelector(FILTER_TOGGLE_SELECTOR);
    if (filterToggle && !actionsWrapper.contains(filterToggle)) {
      actionsWrapper.appendChild(filterToggle);
    }

    const headEl = widgetSize.querySelector(REVIEWS_HEAD_SELECTOR);
    if (headEl) {
      headEl.classList.add(...REVIEWS_HEAD_CLASSES);
      if (!reviewsControls.contains(headEl)) {
        reviewsControls.appendChild(headEl);
      }
    }
  }

  function ensureHeaderContentModulesRow(widgetSize) {
    const headerContent = widgetSize.querySelector(HEADER_CONTENT_SELECTOR);
    if (!headerContent) return;

    const modulesGroup = headerContent.lastElementChild;
    if (!modulesGroup) return;

    modulesGroup.classList.add('lg:!flex-row');

    const firstModule = modulesGroup.firstElementChild;
    if (firstModule) {
      firstModule.style.order = firstModule.childElementCount === 0 ? '2' : '';
    }
  }

  function ensureCarouselNextIcons(widgetSize) {
    widgetSize.querySelectorAll(CAROUSEL_NEXT_SELECTOR).forEach((button) => {
      if (button.querySelector(`.${CAROUSEL_NEXT_ICON_CLASS}`)) return;

      button.insertAdjacentHTML('beforeend', CAROUSEL_NEXT_ICON_SVG);
    });
  }

  function ensureCarouselNextButtonPlacement(widgetSize) {
    const twoThirds = widgetSize.querySelector(HEADER_CONTENT_TWO_THIRDS_SELECTOR);
    if (!twoThirds) return;

    const nextButton = twoThirds.querySelector(CAROUSEL_NEXT_SELECTOR);
    if (!nextButton || nextButton.parentElement === twoThirds) return;

    twoThirds.appendChild(nextButton);
  }

  function ensureCarouselNextButtonEnabled(widgetSize) {
    const twoThirds = widgetSize.querySelector(HEADER_CONTENT_TWO_THIRDS_SELECTOR);
    if (!twoThirds) return;

    const nextButton = twoThirds.querySelector(CAROUSEL_NEXT_SELECTOR);
    if (!nextButton || !nextButton.hasAttribute('disabled')) return;

    nextButton.removeAttribute('disabled');
  }

  function ensureCarouselPrevIcons(widgetSize) {
    widgetSize.querySelectorAll(CAROUSEL_PREV_SELECTOR).forEach((button) => {
      if (button.querySelector(`.${CAROUSEL_PREV_ICON_CLASS}`)) return;

      button.insertAdjacentHTML('beforeend', CAROUSEL_PREV_ICON_SVG);
    });
  }

  function ensureGalleryNavIcons() {
    document.querySelectorAll(GALLERY_NAV_NEXT_SELECTOR).forEach((button) => {
      if (button.querySelector(`.${CAROUSEL_NEXT_ICON_CLASS}`)) return;

      button.insertAdjacentHTML('beforeend', CAROUSEL_NEXT_ICON_SVG);
    });

    document.querySelectorAll(GALLERY_NAV_PREV_SELECTOR).forEach((button) => {
      if (button.querySelector(`.${CAROUSEL_PREV_ICON_CLASS}`)) return;

      button.insertAdjacentHTML('beforeend', CAROUSEL_PREV_ICON_SVG);
    });
  }

  function getModalProductName() {
    const nameEl = document.querySelector(PRODUCT_NAME_SELECTOR);
    if (!nameEl) return '';

    const clone = nameEl.cloneNode(true);
    clone.querySelectorAll(PRODUCT_VARIANT_SELECTOR).forEach((variant) => variant.remove());

    return clone.textContent.trim();
  }

  function ensureModalTitle() {
    const modal = document.querySelector(MODAL_SELECTOR);
    if (!modal) return;

    const closeButton = modal.querySelector(MODAL_CLOSE_SELECTOR);
    if (!closeButton) return;

    const header = closeButton.parentElement;
    if (!header) return;

    header.classList.add(MODAL_HEADER_CLASS);

    if (header.querySelector(`:scope > .${MODAL_TITLE_CLASS}`)) return;

    const productName = getModalProductName();
    if (!productName) return;


    const title = document.createElement('h5');
    title.classList.add(MODAL_TITLE_CLASS);
    title.textContent = `Opinia o ${productName}`;

    header.insertBefore(title, closeButton);
  }

  function ensureModalReviewVariantPlacement() {
    const modal = document.querySelector(MODAL_SELECTOR);
    if (!modal) return;

    const variant = modal.querySelector(REVIEW_SIMPLE_VARIANT_SELECTOR);
    if (!variant) return;

    const nameEl = modal.querySelector(PRODUCT_NAME_SELECTOR);
    if (!nameEl) return;

    if (nameEl.nextElementSibling === variant) return;

    nameEl.insertAdjacentElement('afterend', variant);
  }

  function ensureFilterToggleIcons(widgetSize) {
    widgetSize.querySelectorAll(FILTER_TOGGLE_ICON_SELECTOR).forEach((iconSpan) => {
      if (iconSpan.querySelector(`.${FILTER_TOGGLE_ICON_CLASS}`)) return;

      iconSpan.insertAdjacentHTML('beforeend', FILTER_TOGGLE_ICON_SVG);
    });
  }

  function ensureTextSearchFilterIcons(widgetSize) {
    widgetSize.querySelectorAll(TEXT_SEARCH_FILTER_SELECTOR).forEach((filter) => {
      if (filter.querySelector(`.${TEXT_SEARCH_FILTER_ICON_CLASS}`)) return;

      filter.insertAdjacentHTML('afterbegin', TEXT_SEARCH_FILTER_ICON_SVG);
    });
  }

  function ensureReviewsSummaryCount(widgetSize) {
    const container = widgetSize.querySelector(REVIEWS_SUMMARY_CONTAINER_SELECTOR);
    if (!container) return;

    const summaryEl = container.querySelector(REVIEWS_SUMMARY_TEXT_SELECTOR);
    if (!summaryEl) return;

    const countEl = widgetSize.querySelector(NAV_BAR_ITEM_COUNT_SELECTOR);
    const count = countEl ? countEl.textContent.trim() : '';
    if (!count) return;

    let wrapper = container.querySelector(`:scope > .${REVIEWS_SUMMARY_COUNT_CLASS}`);
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.classList.add(REVIEWS_SUMMARY_COUNT_CLASS, ...REVIEWS_SUMMARY_COUNT_CLASSES);
      wrapper.innerHTML = REVIEWS_SUMMARY_COUNT_ICON_SVG + `<span class="${REVIEWS_SUMMARY_COUNT_TEXT_CLASS}"></span>`;
      container.appendChild(wrapper);
    } else if (container.lastElementChild !== wrapper) {
      container.appendChild(wrapper);
    }

    const textEl = wrapper.querySelector(`.${REVIEWS_SUMMARY_COUNT_TEXT_CLASS}`);
    const text = `Podsumowanie na podstawie ${count} opinii klientów`;
    if (textEl.textContent !== text) textEl.textContent = text;
  }

  function ensureReviewsKeywordsHeadingText(widgetSize) {
    widgetSize.querySelectorAll(REVIEWS_KEYWORDS_HEADING_TEXT_SELECTOR).forEach((headingText) => {
      if (headingText.textContent.trim() === REVIEWS_KEYWORDS_HEADING_TEXT) return;

      headingText.textContent = REVIEWS_KEYWORDS_HEADING_TEXT;
    });
  }

  function ensureQuestionsEmptyState() {
    const emptyState = document.querySelector(QUESTIONS_EMPTY_STATE_SELECTOR);
    if (!emptyState) return;

    const textEl = emptyState.querySelector(QUESTIONS_EMPTY_STATE_TEXT_SELECTOR);
    if (textEl && textEl.textContent.trim() !== QUESTIONS_EMPTY_STATE_TEXT_CONTENT) {

      textEl.textContent = QUESTIONS_EMPTY_STATE_TEXT_CONTENT;
    }

    if (!emptyState.querySelector(`:scope > .${QUESTIONS_EMPTY_STATE_HEADING_CLASS}`)) {

      const heading = document.createElement('h3');
      heading.classList.add(QUESTIONS_EMPTY_STATE_HEADING_CLASS);
      heading.textContent = QUESTIONS_EMPTY_STATE_HEADING_TEXT;
      emptyState.insertBefore(heading, emptyState.firstChild);
    }
  }

  function ensureReviewsEmptyState() {
    const emptyState = document.querySelector(REVIEWS_EMPTY_STATE_SELECTOR);
    if (!emptyState) return;

    const textEl = emptyState.querySelector(REVIEWS_EMPTY_STATE_TEXT_SELECTOR);
    if (textEl && textEl.textContent.trim() !== REVIEWS_EMPTY_STATE_TEXT_CONTENT) {

      textEl.textContent = REVIEWS_EMPTY_STATE_TEXT_CONTENT;
    }

    if (!emptyState.querySelector(`:scope > .${REVIEWS_EMPTY_STATE_HEADING_CLASS}`)) {
      const heading = document.createElement('h3');
      heading.classList.add(REVIEWS_EMPTY_STATE_HEADING_CLASS);
      heading.textContent = REVIEWS_EMPTY_STATE_HEADING_TEXT;
      emptyState.insertBefore(heading, emptyState.firstChild);
    }
  }

  function wrapQuestionBodyText(body) {
    if (body.querySelector(`:scope > .${QW_QUESTION_TEXT_CLASS}`)) return;

    const span = document.createElement('span');
    span.classList.add(QW_QUESTION_TEXT_CLASS);

    while (body.firstChild) {
      span.appendChild(body.firstChild);
    }

    body.appendChild(span);
  }

  function moveNewAnswersIntoContent(outer, content) {
    outer.querySelectorAll(`:scope > ${QW_ANSWER_SELECTOR}`).forEach((answer) => {
      if (!content.contains(answer)) content.appendChild(answer);
    });
  }

  function ensureQwLayout(question) {
    const parent = question.parentElement;
    if (!parent) return;

    if (parent.classList.contains(QW_CONTENT_CLASS)) {
      const content = parent;
      const outer = content.parentElement;
      if (outer) moveNewAnswersIntoContent(outer, content);
      return;
    }

    const outer = parent;

    const avatar = question.querySelector(`:scope > .oke-qw-question-avatar`);
    const main = question.querySelector(`:scope > .oke-qw-question-main`);
    if (!avatar || !main) return;

    const author = main.querySelector(`:scope > .oke-qw-question-main-author`);
    const date = main.querySelector(`:scope > .oke-qw-question-main-date`);
    const body = main.querySelector(`:scope > .oke-qw-question-main-body`);
    if (!author || !date || !body) return;


    const side = document.createElement('div');
    side.classList.add(QW_SIDE_CLASS);
    side.appendChild(avatar);
    side.appendChild(author);
    author.insertAdjacentHTML('afterend', QW_VERIFIED_HTML);

    wrapQuestionBodyText(body);
    body.appendChild(date);

    const content = document.createElement('div');
    content.classList.add(QW_CONTENT_CLASS);

    outer.insertBefore(side, question);
    outer.insertBefore(content, question);
    content.appendChild(question);

    moveNewAnswersIntoContent(outer, content);
  }

  function ensureQwSideWrappers() {
    document.querySelectorAll(QW_QUESTION_SELECTOR).forEach((question) => ensureQwLayout(question));
  }

  function moveWriteReviewButton(widgetSize) {
    const writeReviewEl = widgetSize.querySelector(WRITE_REVIEW_SELECTOR);

    if (!writeReviewEl) {
      
      return;
    }

    let wrapper = widgetSize.querySelector(`:scope > .${CUSTOM_WRAPPER_CLASS}`);

    if (!wrapper) {
     
      wrapper = document.createElement('div');
      wrapper.classList.add(CUSTOM_WRAPPER_CLASS, 'flex', 'flex-col', 'lg:flex-row', 'justify-between');
      widgetSize.insertBefore(wrapper, widgetSize.firstChild);
    }

    ensureTitle(wrapper, TITLE_TEXT);
    ensureWrapperAfterControls(widgetSize, wrapper);
    ensureReviewsControlsLayout(widgetSize);
    ensureHeaderContentModulesRow(widgetSize);
    ensureCarouselNextIcons(widgetSize);
    ensureCarouselNextButtonPlacement(widgetSize);
    ensureCarouselNextButtonEnabled(widgetSize);
    ensureCarouselPrevIcons(widgetSize);
    ensureFilterToggleIcons(widgetSize);
    ensureTextSearchFilterIcons(widgetSize);
    ensureReviewsSummaryCount(widgetSize);
    ensureReviewsKeywordsHeadingText(widgetSize);

    if (!wrapper.contains(writeReviewEl)) {
     
      wrapper.appendChild(writeReviewEl);
    }

    updateHeaderVisibility(widgetSize);
  }

  function updateHeaderVisibility(widgetSize) {
    const wrapper = widgetSize.querySelector(`:scope > .${CUSTOM_WRAPPER_CLASS}`);
    if (!wrapper) return;

    wrapper.style.display = isQuestionsTabActive ? 'none' : '';
  }

  function handleTabSelectionChange(mutations) {
    mutations.forEach((mutation) => {
      const tab = mutation.target;
      if (!(tab instanceof Element) || tab.getAttribute('role') !== 'tab') return;
      if (tab.getAttribute('aria-selected') !== 'true') return;

      if (tab.id.startsWith(QUESTIONS_TAB_ID_PREFIX)) {
        isQuestionsTabActive = true;
      } else if (tab.id.startsWith(REVIEWS_TAB_ID_PREFIX)) {
        isQuestionsTabActive = false;
      } else {
        return;
      }

     

      const widgetSize = document.querySelector(WIDGET_SIZE_SELECTOR);
      if (widgetSize) updateHeaderVisibility(widgetSize);
    });
  }

  function detectInitialActiveTab() {
    const activeTab = document.querySelector(`${TAB_SELECTOR}[aria-selected="true"]`);
    if (activeTab && activeTab.id.startsWith(QUESTIONS_TAB_ID_PREFIX)) {
      isQuestionsTabActive = true;
    }
  }

  function init() {
  

    detectInitialActiveTab();

    const tabsObserver = new MutationObserver(handleTabSelectionChange);
    tabsObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-selected'],
      subtree: true,
    });

    const existingWidgetSize = document.querySelector(WIDGET_SIZE_SELECTOR);
    if (existingWidgetSize) {
      moveWriteReviewButton(existingWidgetSize);
    }
    ensureQuestionsEmptyState();
    ensureReviewsEmptyState();
    ensureQwSideWrappers();
    ensureQuestionsHeaderTitle();
    ensureGalleryNavIcons();
    ensureModalTitle();
    ensureModalReviewVariantPlacement();

    const observer = new MutationObserver(() => {
      const widgetSize = document.querySelector(WIDGET_SIZE_SELECTOR);
      if (widgetSize) moveWriteReviewButton(widgetSize);

      ensureQuestionsEmptyState();
      ensureReviewsEmptyState();
      ensureQwSideWrappers();
      ensureQuestionsHeaderTitle();
      ensureGalleryNavIcons();
      ensureModalTitle();
      ensureModalReviewVariantPlacement();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
